// Temporizador de trechos (0.67, texto 05 A1/A2/G3): atividade e pausas de uma tarefa do My Planner,
// ou matérias e pausas de uma sessão de estudo. Só cálculo; a tela fica em components/MiniTemporizador.
export type Trecho = { tipo: 'ativ' | 'pausa'; min: number; nome?: string; emoji?: string };
export type EstadoTrecho = {
  i: number;                 // índice do trecho atual (-1 = ainda não começou; trechos.length = acabou)
  trecho: Trecho | null;
  feitoMin: number;          // minutos já feitos deste trecho
  faltaMin: number;          // minutos que faltam para este trecho acabar
  nAtiv: number; totalAtiv: number;     // "atividade 2 de 7"
  nPausa: number; totalPausa: number;   // "pausa 2 de 6"
  ultimo: boolean;           // é o último trecho (não há pausa depois)
  fimTrechoMs: number;       // quando o trecho atual acaba (epoch ms)
  inicioMs: number; fimMs: number; agoraMs: number;
};
/** Onde a pessoa está agora: começo em ms, lista de trechos, agora em ms. pausadoMs: tempo parado (sessão pausada). */
export function estadoAgora(inicioMs: number, trechos: Trecho[], agoraMs = Date.now(), pausadoMs = 0): EstadoTrecho {
  const totalAtiv = trechos.filter(x => x.tipo === 'ativ').length, totalPausa = trechos.length - totalAtiv;
  const fimMs = inicioMs + trechos.reduce((s, x) => s + x.min, 0) * 60000 + pausadoMs;
  const base = { totalAtiv, totalPausa, inicioMs, fimMs, agoraMs };
  const t = agoraMs - inicioMs - pausadoMs;
  if (t < 0) return { ...base, i: -1, trecho: null, feitoMin: 0, faltaMin: Math.ceil(-t / 60000), nAtiv: 0, nPausa: 0, ultimo: false, fimTrechoMs: inicioMs };
  let acc = 0, nAtiv = 0, nPausa = 0;
  for (let i = 0; i < trechos.length; i++) {
    const x = trechos[i], dur = x.min * 60000;
    if (x.tipo === 'ativ') nAtiv++; else nPausa++;
    if (t < acc + dur) {
      const feito = t - acc;
      return { ...base, i, trecho: x, feitoMin: Math.floor(feito / 60000), faltaMin: Math.ceil((dur - feito) / 60000), nAtiv, nPausa,
        ultimo: i === trechos.length - 1, fimTrechoMs: inicioMs + pausadoMs + acc + dur };
    }
    acc += dur;
  }
  return { ...base, i: trechos.length, trecho: null, feitoMin: 0, faltaMin: 0, nAtiv, nPausa, ultimo: true, fimTrechoMs: fimMs };
}
/** Fração (0..1) de onde cada trecho começa e termina, para a barrinha. */
export function partesDaBarra(trechos: Trecho[]) {
  const total = trechos.reduce((s, x) => s + x.min, 0) || 1;
  let acc = 0;
  return trechos.map(x => { const r = { tipo: x.tipo, de: acc / total, ate: (acc + x.min) / total }; acc += x.min; return r; });
}
